import React, { FC } from 'react';
// mui components
import { Grid, IconButton, SxProps, Typography } from '@mui/material';
// icons
import CloseIcon from 'assets/icons/close.svg';
import UploadErrorIcon from 'assets/icons/files/upload-error-icon.svg';
// types
import { ISelectionUploadingFile } from 'redux-store/api/selections';
// helpers
import { convertBytes } from 'utils/helpers';
import { getRowIcon as renderIcon } from 'utils/helpers/fileCabinetHelpers';
// styles
import { styles } from './styles';
import { Theme } from '@mui/system';
import { RoundProgress } from 'components/round-progress';

interface IProps {
  uploadingFiles?: ISelectionUploadingFile[];
  handleDeleteUploadedData?: (fileId: number | string) => void;
  canDelete: boolean;
  sx?: SxProps<Theme>;
}

const UploadedFiles: FC<IProps> = ({ uploadingFiles, handleDeleteUploadedData, canDelete, sx }) => {
  if (!uploadingFiles.length) {
    return null;
  }

  return (
    <Grid sx={styles.container}>
      {uploadingFiles.map(({ name, tempId, percent, id, status, size, mimeType }) => {
        const Icon = renderIcon('file', mimeType);

        return (
          <Grid
            key={tempId}
            sx={{
              ...styles.itemContainer,
              border:
                status === 'error_file_size' || status === 'error_upload'
                  ? '1px solid #D12D36'
                  : '1px solid #EDEFF7',
              ...sx,
            }}
          >
            <Grid sx={styles.firstPartContainer}>
              <Grid sx={styles.iconContainer}>
                {status === 'error_file_size' || status === 'error_upload' ? (
                  <UploadErrorIcon height={24} width={24} />
                ) : (
                  <Icon />
                )}
              </Grid>

              <Grid sx={styles.nameContainer}>
                <Typography sx={styles.name}>{name}</Typography>
                <Typography
                  sx={{
                    ...styles.status,
                    color: status === 'error_file_size' ? '#D12D36' : '#6E707A',
                  }}
                >
                  {status === 'error_file_size'
                    ? 'The file size is too large and cannot be uploaded.'
                    : size
                      ? convertBytes(size)
                      : ''}
                </Typography>
              </Grid>
            </Grid>
            <Grid sx={styles.secondPartContainer}>
              {!['done', 'error_file_size', 'error_upload'].includes(status) && (
                <RoundProgress value={percent} size={40} />
              )}
              {canDelete && (
                <IconButton
                  sx={styles.iconBtn}
                  onClick={() => {
                    handleDeleteUploadedData(id);
                  }}
                >
                  <CloseIcon />
                </IconButton>
              )}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default UploadedFiles;
